import cx from 'classnames';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Tooltip} from 'components/UIKit';
import {TRANSLATION_KEYS} from 'locale';
import {OnlineStatus} from 'types';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.ONLINE_STATE;

type Props = {
    status: OnlineStatus,
    reverseAlign?: boolean;
    tooltip?: boolean;
    size?: 'sm' | 'md';
    iconClassName?: string;
}

export const OnlineStatusIcon = ({status, reverseAlign, tooltip = true, size = 'sm', iconClassName}: Props) => {
    const {t} = useTranslation();
    const tooltipTitle = useMemo(() => {
        switch (status) {
            case OnlineStatus.Online: return t(T_KEYS.ONLINE);
            case OnlineStatus.Away: return t(T_KEYS.AWAY);
            case OnlineStatus.Offline: return t(T_KEYS.OFFLINE);
            default: return '';
        }
    }, [status, t]);

    return (
        <Tooltip disabled={!tooltip} message={tooltipTitle}>
            <div className={cx(
                iconClassName,
                'tw-flex-shrink-0 tw-inline-block tw-rounded',
                reverseAlign ? 'tw-mr-1.5' : 'tw-ml-1.5',
                {
                    'tw-bg-success-light': status === OnlineStatus.Online,
                    'tw-bg-warning-light': status === OnlineStatus.Away,
                    'tw-bg-alert': status === OnlineStatus.Offline,
                    'tw-w-1.5 tw-h-1.5': size === 'sm',
                    'tw-w-2 tw-h-2': size === 'md',
                })}
            />
        </Tooltip>
    );
};